import axios from 'axios'
class ApiService {
  constructor () {
    console.log('CONSTRUCT GLOBAL ApiService')
  }

  async getRoomByProtocol (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/rooms/get-room-protocol`;
    try {
      const response = await axios.post(url, payload);
      return response.data
    } catch (err) {
      console.error('[getRoomByProtocol]', err)
    }
  }
  
  async saveTeleconsultMovimentLog (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/teleconsult/save-log`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveTeleconsultMovimentLog]', err)
    }
  }
  
  async saveNps (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/nps/save-nps`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveNps]', err)
    }
  }

  async sendNotification (payload) {
    const url = `${process.env.VUE_APP_LOTUS_MINHA_SAUDE}/api/expo/notification`;
    try {
      await axios.post(url, payload);
    } catch (err) {
      console.error('[saveTeleconsultMovimentLog]', err)
    }
  }
}

export default ApiService
